import { render, staticRenderFns } from "./StockBatchExpiryTable.vue?vue&type=template&id=b6e93d68"
import script from "./StockBatchExpiryTable.vue?vue&type=script&lang=ts"
export * from "./StockBatchExpiryTable.vue?vue&type=script&lang=ts"
import style0 from "./StockBatchExpiryTable.vue?vue&type=style&index=0&id=b6e93d68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports